"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@cimpress/react-components");

var _reactI18next = require("react-i18next");

var _i18n = require("../../i18n");

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tt(props, key) {
  var t = props.t,
      language = props.language;
  return t(key, {
    lng: language
  });
}

var ErrorInfo = function ErrorInfo(props) {
  return _react.default.createElement("div", {
    className: 'card'
  }, _react.default.createElement("div", {
    className: 'card-block'
  }, _react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, _react.default.createElement("div", {
    style: {
      marginRight: '10px'
    }
  }, _react.default.createElement(_reactStreamlineIcons.IconAlertTriangle, {
    size: '2x',
    color: _reactComponents.colors.persimmon.base
  }), "\xA0"), _react.default.createElement("div", null, props.error.message)), _react.default.createElement("br", null), _react.default.createElement("div", null, props.error.response ? _react.default.createElement("em", null, JSON.stringify(props.error.response.data)) : null), props.onAcknowledgeClick ? _react.default.createElement("div", {
    align: "right"
  }, _react.default.createElement("button", {
    className: 'btn btn-outline-secondary',
    onClick: function onClick() {
      return props.onAcknowledgeClick();
    }
  }, tt(props, 'button_ok'))) : null));
};

ErrorInfo.propTypes = {
  error: _propTypes.default.any,
  onAcknowledgeClick: _propTypes.default.func
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(ErrorInfo);

exports.default = _default;